export default function ({commit}) {
    commit('clean');
    commit('form/clean');
    commit('list/clean');
}